export class OtherKpExportModel {
  constructor() { }
  statusKP: string = null
  id: string = null
  kamName: string = null
  customerName: string = null
  distributorName: string = null
  amountPosition: number = null
  summKp: number = null
  dateCreate: string = null
}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/models/other-kp-export-model.ts